/*eslint-disable */
/*
  need to disable this file as there are 4 issues with using camelcase.  I don't know what we can change at this point
  and have it not affect an api call.
*/
// Returns object that describes GDPR checkbox object
const deriveGDPRObject = (nextLineSortOrder: number) => {
  var gdprFieldObject: {
    constrain_by: string;
    defaultValue?: string;
    disabled: boolean;
    errorMessage: string;
    fieldId: string;
    inputType: string;
    label: string;
    list: any;
    placeholder: string;
    required: boolean;
    showBoolean: boolean;
    show_if: string;
    sortOrder: string;
    compressHeight?: boolean;
    __typename: string;
  } = {
    constrain_by: '[]',
    defaultValue: null,
    disabled: false,
    errorMessage: null,
    fieldId: 'gdpr_compliance',
    inputType: 'gdpr_consent_checkbox',
    label:
      'I have read and accept the YouVisit Terms of Use and Privacy Policy',
    list: [],
    placeholder: '',
    required: false,
    showBoolean: true,
    show_if: '[]',
    sortOrder: JSON.stringify(nextLineSortOrder),
    compressHeight: true,
    __typename: 'Field',
  };
  return gdprFieldObject;
};

// Returns object that describes GDPR checkbox object
const deriveMarketingObject = (nextLineSortOrder: number) => {
  var gdprFieldObject: {
    constrain_by: string;
    defaultValue: string;
    disabled: boolean;
    errorMessage: string;
    fieldId: string;
    inputType: string;
    label: string;
    list: any;
    placeholder: string;
    required: boolean;
    showBoolean: boolean;
    show_if: string;
    sortOrder: string;
    compressHeight?: boolean;
    __typename: string;
  } = {
    constrain_by: '[]',
    defaultValue: null,
    disabled: false,
    errorMessage: null,
    fieldId: 'marketing_compliance',
    inputType: 'marketing_consent_checkbox',
    label: 'I consent to receiving marketing materials',
    list: [],
    placeholder: '',
    required: false,
    showBoolean: true,
    show_if: '[]',
    sortOrder: JSON.stringify(nextLineSortOrder),
    compressHeight: true,
    __typename: 'Field',
  };
  return gdprFieldObject;
};

// Adds required checkbox to first step if GDPR compliance required based on locale
const decorateWithGDPRCompliance = (steps: any) => {
  // Add checkbox to first step
  return steps.map((step: any, idx: number) => {
    if (idx === 0) {
      // Get sortOrder value of last field and add 0.1 on it so that it appears on the next line, then convert back to string
      let sortOrderVal = parseFloat(
        step.fields[step.fields.length - 1].sortOrder
      );
      let nextLineSortOrder = sortOrderVal > 0 ?sortOrderVal + 0.1:sortOrderVal - 0.1;     

      step.fields = step.fields.concat(deriveGDPRObject(nextLineSortOrder));

      if (sortOrderVal > 0) {
        nextLineSortOrder = sortOrderVal + 1;
      } else {
        nextLineSortOrder = sortOrderVal - 1;
      }

      step.fields = step.fields.concat(
        deriveMarketingObject(nextLineSortOrder)
      );

      return Object.assign({}, step);
    } else {
      step.fields = step.fields.concat();
      return Object.assign({}, step);
    }
  });
};

export default decorateWithGDPRCompliance;
try {
    // @ts-ignore
    decorateWithGDPRCompliance.displayName = "decorateWithGDPRCompliance";
    // @ts-ignore
    decorateWithGDPRCompliance.__docgenInfo = { "description": "", "displayName": "decorateWithGDPRCompliance", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/containers/stepContainer/dataTransform/decorateWithGDPRCompliance.ts#decorateWithGDPRCompliance"] = { docgenInfo: decorateWithGDPRCompliance.__docgenInfo, name: "decorateWithGDPRCompliance", path: "src/containers/stepContainer/dataTransform/decorateWithGDPRCompliance.ts#decorateWithGDPRCompliance" };
}
catch (__react_docgen_typescript_loader_error) { }